import {createEntityThunks} from 'utils/createEntityThunks';
import {Company} from 'types/company';
import {CompanyService} from 'services/companyService';
import {createAsyncThunk} from '@reduxjs/toolkit';

const companyFactory = (data: any) => new Company(data);

export const BaseCompanyThunks = createEntityThunks<Company>(
  'company',
  CompanyService,
  {activate: false, deactivate: false},
  companyFactory,
);

export class CompanyThunks extends BaseCompanyThunks {
  static getCurrent = createAsyncThunk('company/getCurrent', async () => {
    return await CompanyService.getCurrent();
  });
}
